import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'saudi_erp_sidebar_open';

const SaudiSidebarLayoutContext = createContext(null);

function readStoredOpen() {
  try {
    return localStorage.getItem(STORAGE_KEY) !== '0';
  } catch {
    return true;
  }
}

function persistOpen(open) {
  try {
    localStorage.setItem(STORAGE_KEY, open ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function SaudiSidebarLayoutProvider({ children }) {
  const [open, setOpen] = useState(readStoredOpen);

  const setOpenPersisted = useCallback((next) => {
    setOpen(next);
    persistOpen(next);
  }, []);

  const toggle = useCallback(() => {
    setOpen((prev) => {
      const next = !prev;
      persistOpen(next);
      return next;
    });
  }, []);

  const close = useCallback(() => {
    setOpenPersisted(false);
  }, [setOpenPersisted]);

  const value = useMemo(() => ({ open, toggle, close }), [close, open, toggle]);

  return (
    <SaudiSidebarLayoutContext.Provider value={value}>
      {children}
    </SaudiSidebarLayoutContext.Provider>
  );
}

export function useSaudiSidebarLayout() {
  const ctx = useContext(SaudiSidebarLayoutContext);
  if (!ctx) {
    throw new Error('useSaudiSidebarLayout requires SaudiSidebarLayoutProvider');
  }
  return ctx;
}

export default SaudiSidebarLayoutContext;
